import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "left-wrap"
}
const _hoisted_2 = { class: "left-title" }
const _hoisted_3 = { class: "title-text" }
const _hoisted_4 = { class: "btn-text" }
const _hoisted_5 = { class: "left-skins" }
const _hoisted_6 = {
  key: 0,
  class: "skins-wrap"
}
const _hoisted_7 = {
  key: 1,
  class: "skins-empty"
}
const _hoisted_8 = { class: "cart-bottom" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "content-top" }
const _hoisted_11 = { class: "content-title" }
const _hoisted_12 = { class: "title-left" }
const _hoisted_13 = { class: "filters-price" }
const _hoisted_14 = { class: "bottom-cart" }
const _hoisted_15 = { class: "cart-nob" }
const _hoisted_16 = { class: "left-title" }
const _hoisted_17 = { class: "title-text" }
const _hoisted_18 = { class: "btn-text" }
const _hoisted_19 = { class: "left-skins" }
const _hoisted_20 = {
  key: 0,
  class: "skins-wrap"
}
const _hoisted_21 = {
  key: 1,
  class: "skins-empty"
}
const _hoisted_22 = { class: "bottom-btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CartItem = _resolveComponent("CartItem")!
  const _component_CartStats = _resolveComponent("CartStats")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_InputSmall = _resolveComponent("InputSmall")!
  const _component_FilterDropdown = _resolveComponent("FilterDropdown")!
  const _component_ItemsContainer = _resolveComponent("ItemsContainer")!
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["center-wrap", { mobile: _ctx.mobile }])
  }, [
    (!_ctx.mobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('Home.cart')), 1),
            _createElementVNode("div", {
              class: "title-btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
            }, [
              _cache[11] || (_cache[11] = _createStaticVNode("<svg width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" fill=\"none\" data-v-a0662bfe><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.0025 22.0038H6.99754C6.46684 22.0039 5.95783 21.7931 5.58257 21.4179C5.20731 21.0426 4.9967 20.5336 4.9967 20.0029V9.49855C4.99701 8.6699 5.66868 7.99823 6.49733 7.99792H19.5027C20.3314 7.99823 21.0031 8.6699 21.0034 9.49855V20.0029C21.0034 20.5336 20.7928 21.0426 20.4175 21.4179C20.0422 21.7931 19.5332 22.0039 19.0025 22.0038Z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-a0662bfe></path><path d=\"M8.99829 7.99791V7.74781V7.74781C8.99829 5.6759 10.6779 3.9963 12.7499 3.99625H13.2501C15.322 3.9963 17.0016 5.6759 17.0016 7.74781V7.74781V7.99791\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-a0662bfe></path><path d=\"M14.2506 13.9466L11.7495 16.4477\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-a0662bfe></path><path d=\"M11.7495 13.9466L14.2506 16.4477\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-a0662bfe></path></svg>", 1)),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t('Home.clear')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.selectedItems.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedItems, (item) => {
                    return (_openBlock(), _createBlock(_component_CartItem, {
                      key: item.id,
                      name: item.item.name,
                      icon: item.item.icon,
                      price: item.item.priceUsd,
                      exterior: item.item.exterior,
                      stattrak: item.item.stattrak,
                      color: item.item.color,
                      type: item.item.type,
                      onRemove: ($event: any) => (_ctx.select(item))
                    }, null, 8, ["name", "icon", "price", "exterior", "stattrak", "color", "type", "onRemove"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (!_ctx.selectedItems.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.t('Home.empty')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_CartStats, {
              skins: _ctx.skins,
              total: _ctx.total
            }, null, 8, ["skins", "total"]),
            _createVNode(_component_BaseButton, {
              class: _normalizeClass(["b-8 buy-btn", [_ctx.buyBtnClass]]),
              onClick: _ctx.buy,
              loading: _ctx.buying
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.buyBtnText), 1)
              ]),
              _: 1
            }, 8, ["class", "onClick", "loading"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t('Home.title')), 1),
          (_openBlock(), _createElementBlock("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            class: "title-right",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleFilters && _ctx.toggleFilters(...args)))
          }, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M5 3.75C4.30921 3.75 3.75 4.30921 3.75 5V19C3.75 19.6908 4.30921 20.25 5 20.25H19C19.6908 20.25 20.25 19.6908 20.25 19V5C20.25 4.30921 19.6908 3.75 19 3.75H5ZM2.25 5C2.25 3.48079 3.48079 2.25 5 2.25H19C20.5192 2.25 21.75 3.48079 21.75 5V19C21.75 20.5192 20.5192 21.75 19 21.75H5C3.48079 21.75 2.25 20.5192 2.25 19V5ZM9 6.25C9.41421 6.25 9.75 6.58579 9.75 7V8.25H10C10.9662 8.25 11.75 9.03379 11.75 10V11C11.75 11.9662 10.9662 12.75 10 12.75H9.75V17C9.75 17.4142 9.41421 17.75 9 17.75C8.58579 17.75 8.25 17.4142 8.25 17V12.75H8C7.03379 12.75 6.25 11.9662 6.25 11V10C6.25 9.03379 7.03379 8.25 8 8.25H8.25V7C8.25 6.58579 8.58579 6.25 9 6.25ZM10 11.25H9H8C7.86221 11.25 7.75 11.1378 7.75 11V10C7.75 9.86221 7.86221 9.75 8 9.75H9H10C10.1378 9.75 10.25 9.86221 10.25 10V11C10.25 11.1378 10.1378 11.25 10 11.25ZM15 6.25C15.4142 6.25 15.75 6.58579 15.75 7V11.25H16C16.9662 11.25 17.75 12.0338 17.75 13V14C17.75 14.9662 16.9662 15.75 16 15.75H15.75V17C15.75 17.4142 15.4142 17.75 15 17.75C14.5858 17.75 14.25 17.4142 14.25 17V15.75H14C13.0338 15.75 12.25 14.9662 12.25 14V13C12.25 12.0338 13.0338 11.25 14 11.25H14.25V7C14.25 6.58579 14.5858 6.25 15 6.25ZM15 14.25H16C16.1378 14.25 16.25 14.1378 16.25 14V13C16.25 12.8622 16.1378 12.75 16 12.75H15H14C13.8622 12.75 13.75 12.8622 13.75 13V14C13.75 14.1378 13.8622 14.25 14 14.25H15Z",
              fill: "#AFB1C0"
            }, null, -1)
          ]))]))
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["content-filters", { active: _ctx.filters }])
        }, [
          _createVNode(_component_InputSmall, {
            modelValue: _ctx.search,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
            placeholder: _ctx.t('Home.search'),
            class: "filters-search"
          }, {
            left: _withCtx(() => [...(_cache[13] || (_cache[13] = [
              _createElementVNode("svg", {
                width: "26",
                height: "26",
                viewBox: "0 0 26 26",
                fill: "none"
              }, [
                _createElementVNode("path", {
                  d: "M21.0033 21.0033L17.752 17.752",
                  stroke: "#3F8CFF",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }),
                _createElementVNode("path", {
                  d: "M17.749 7.18456C20.6662 10.1018 20.6662 14.8316 17.749 17.7489C14.8317 20.6661 10.1019 20.6661 7.18466 17.7489C4.2674 14.8316 4.26738 10.1018 7.18462 7.18456C8.58554 5.78362 10.4856 4.99658 12.4668 4.99658C14.448 4.99658 16.3481 5.78362 17.749 7.18456",
                  stroke: "#3F8CFF",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }),
                _createElementVNode("path", {
                  d: "M12.4698 8.96832V12.1917",
                  stroke: "#3F8CFF",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }),
                _createElementVNode("path", {
                  d: "M15.9712 12.97C15.9712 12.5401 15.6227 12.1917 15.1929 12.1917H9.74659C9.31673 12.1917 8.96826 12.5401 8.96826 12.97",
                  stroke: "#3F8CFF",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }),
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M9.96868 15.9712H14.9708C15.5233 15.9712 15.9712 15.5233 15.9712 14.9708V11.4043C15.9711 10.9989 15.8891 10.5977 15.7301 10.2248L15.452 9.57558C15.2946 9.20743 14.9329 8.96854 14.5326 8.96832H10.4069C10.0061 8.96814 9.64396 9.20709 9.48648 9.57558L9.20936 10.2238C9.05087 10.5955 8.96887 10.9953 8.96826 11.3993V14.9708C8.96826 15.5233 9.41616 15.9712 9.96868 15.9712Z",
                  stroke: "#3F8CFF",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ], -1)
            ]))]),
            _: 1
          }, 8, ["modelValue", "placeholder"]),
          _createVNode(_component_FilterDropdown, {
            modelValue: _ctx.type,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.type) = $event)),
            placeholder: _ctx.t('Home.type'),
            items: _ctx.types
          }, null, 8, ["modelValue", "placeholder", "items"]),
          _createVNode(_component_FilterDropdown, {
            modelValue: _ctx.rarity,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rarity) = $event)),
            placeholder: _ctx.t('Home.rarity'),
            items: _ctx.rarities
          }, null, 8, ["modelValue", "placeholder", "items"]),
          _createVNode(_component_FilterDropdown, {
            modelValue: _ctx.appId,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.appId) = $event)),
            placeholder: _ctx.t('Home.game'),
            items: _ctx.gameItems
          }, null, 8, ["modelValue", "placeholder", "items"]),
          _createVNode(_component_FilterDropdown, {
            modelValue: _ctx.sortBy,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.sortBy) = $event)),
            placeholder: _ctx.t('Home.sort'),
            items: _ctx.sortItems,
            class: "filters-sort"
          }, null, 8, ["modelValue", "placeholder", "items"]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_InputSmall, {
              modelValue: _ctx.minPrice,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.minPrice) = $event)),
              placeholder: _ctx.t('Home.minPrice')
            }, {
              left: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                _createTextVNode("$", -1)
              ]))]),
              _: 1
            }, 8, ["modelValue", "placeholder"]),
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "divider" }, null, -1)),
            _createVNode(_component_InputSmall, {
              modelValue: _ctx.maxPrice,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.maxPrice) = $event)),
              placeholder: _ctx.t('Home.maxPrice')
            }, {
              left: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                _createTextVNode("$", -1)
              ]))]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ])
        ], 2)
      ]),
      _createVNode(_component_ItemsContainer, {
        class: "items-container-wrap",
        ref: "itemsContainer",
        items: _ctx.items,
        selectedItems: _ctx.selectedItemsComputed,
        onSelect: _ctx.select,
        onScroll: _cache[9] || (_cache[9] = ($event: any) => (_ctx.scrollHandler('itemsContainer')))
      }, null, 8, ["items", "selectedItems", "onSelect"]),
      (_ctx.mobile)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["content-bottom", { active: _ctx.cart }])
          }, [
            _createElementVNode("div", _hoisted_14, [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[17] || (_cache[17] = [
                _createElementVNode("div", { class: "nob" }, null, -1)
              ]))])), [
                [
                  _directive_touch,
                  _ctx.closeCart,
                  "swipe",
                  { bottom: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.t('Home.cart')), 1),
                _createElementVNode("div", {
                  class: "title-btn",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
                }, [
                  _cache[18] || (_cache[18] = _createStaticVNode("<svg width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" fill=\"none\" data-v-a0662bfe><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.0025 22.0038H6.99754C6.46684 22.0039 5.95783 21.7931 5.58257 21.4179C5.20731 21.0426 4.9967 20.5336 4.9967 20.0029V9.49855C4.99701 8.6699 5.66868 7.99823 6.49733 7.99792H19.5027C20.3314 7.99823 21.0031 8.6699 21.0034 9.49855V20.0029C21.0034 20.5336 20.7928 21.0426 20.4175 21.4179C20.0422 21.7931 19.5332 22.0039 19.0025 22.0038Z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-a0662bfe></path><path d=\"M8.99829 7.99791V7.74781V7.74781C8.99829 5.6759 10.6779 3.9963 12.7499 3.99625H13.2501C15.322 3.9963 17.0016 5.6759 17.0016 7.74781V7.74781V7.99791\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-a0662bfe></path><path d=\"M14.2506 13.9466L11.7495 16.4477\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-a0662bfe></path><path d=\"M11.7495 13.9466L14.2506 16.4477\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-a0662bfe></path></svg>", 1)),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.t('Home.clear')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                (_ctx.selectedItems.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedItems, (item) => {
                        return (_openBlock(), _createBlock(_component_CartItem, {
                          key: item.id,
                          name: item.item.name,
                          icon: item.item.icon,
                          price: item.item.priceUsd,
                          exterior: item.item.exterior,
                          stattrak: item.item.stattrak,
                          color: item.item.color,
                          type: item.item.type,
                          onRemove: ($event: any) => (_ctx.select(item))
                        }, null, 8, ["name", "icon", "price", "exterior", "stattrak", "color", "type", "onRemove"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.selectedItems.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.t('Home.empty')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(_component_CartStats, {
              skins: _ctx.skins,
              total: _ctx.total,
              class: "cart-stats-wrap"
            }, null, 8, ["skins", "total"]),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_BaseButton, {
                class: _normalizeClass(["b-8 buy-btn-mobile", [_ctx.buyBtnClass]]),
                onClick: _ctx.buy,
                loading: _ctx.buying
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.buyBtnText), 1)
                ]),
                _: 1
              }, 8, ["class", "onClick", "loading"]),
              _createVNode(_component_BaseButton, {
                class: "b-8 success-dark cart-btn-mobile",
                onClick: _ctx.toggleCart
              }, {
                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                  _createElementVNode("svg", {
                    width: "30",
                    height: "30",
                    viewBox: "0 0 30 30",
                    fill: "none"
                  }, [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M22.2001 25.8H7.80015C6.47415 25.8 5.40015 24.726 5.40015 23.4V10.8C5.40015 9.8064 6.20655 9 7.20015 9H22.8001C23.7937 9 24.6001 9.8064 24.6001 10.8V23.4C24.6001 24.726 23.5261 25.8 22.2001 25.8Z",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }),
                    _createElementVNode("path", {
                      d: "M19.799 12.96C19.6334 12.96 19.499 13.0944 19.5002 13.26C19.5002 13.4256 19.6346 13.56 19.8002 13.56C19.9658 13.56 20.1002 13.4256 20.1002 13.26C20.1002 13.0944 19.9658 12.96 19.799 12.96",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }),
                    _createElementVNode("path", {
                      d: "M10.1989 12.96C10.0333 12.96 9.8989 13.0944 9.9001 13.26C9.9001 13.4256 10.0345 13.56 10.2001 13.56C10.3657 13.56 10.5001 13.4256 10.5001 13.26C10.5001 13.0944 10.3657 12.96 10.1989 12.96",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }),
                    _createElementVNode("path", {
                      d: "M10.2002 9.00001V8.70001V8.70001C10.2002 6.21481 12.215 4.20001 14.7002 4.20001H15.3002C17.7854 4.20001 19.8002 6.21481 19.8002 8.70001V8.70001V9.00001",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ], -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ], 2))
        : _createCommentVNode("", true)
    ])
  ], 2))
}